<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="sendSampleCode"
      resizable
      auto-resize
      highlight-hover-row
      :height="tableHeight"
      :columns="tableColumns"
      :loading="loading"
      :data="tableData"
      :toolbar-config="tableToolbar"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('table_label_action') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:sendSampleStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.sendSampleStatus === 'N'
              ? 'info'
              : row.sendSampleStatus === 'Y'
              ? 'primary'
              : row.sendSampleStatus === 'R'
              ? 'success'
              : row.sendSampleStatus === 'D'
              ? 'danger'
              : 'warning'
          "
        >
          {{ row.v_sendSampleStatus }}
        </el-tag>
      </template>
      <template v-slot:displayConsignees="{ row }">
        <div>{{ row.consignees }}</div>
        <div>
          <span class="mr-1">Tel:</span>
          <span>{{ row.consigneesPhone }}</span>
        </div>
      </template>
      <template v-slot:displayDelivery="{ row }">
        <div>{{ row.deliveryScmName }}</div>
        <div v-if="row.deliveryNo">
          <span class="mr-1"
            >{{ $l('form_label_deliveryNo') || '快递单号' }}:</span
          >
          <span>{{ row.deliveryNo }}</span>
        </div>
      </template>
      <template v-slot:displayCreate="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:displayModify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { format } from '@/libs/util.number.js'
import EditLoading from '@/mixins/edit-loading'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      format,
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { sendSampleCode, sendSampleNo } = data
      if (!menuType) return

      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { sendSampleCode },
            query: { sendSampleNo },
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'shipment':
          this.shipmentConfirm(data)
          break
        case 'receive':
          this.receiveConfirm(data)
          break
        default:
          console.error('menuType configuration error:', menuType)
      }
    },
    async del({ sendSampleCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_delete') || '是否要删除该记录？',
        this.$l('label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('btn_confirm') || '确定',
          cancelButtonText: this.$l('btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .customerSendSampleDelApi({ sendSampleCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async shipmentConfirm({ sendSampleCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_shipmentConfirm') || '是否确认已发货？',
        this.$l('label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('btn_confirm') || '确定',
          cancelButtonText: this.$l('btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .customerSendSampleShipmentConfirmApi({ sendSampleCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_confirm_no') || '确认失败！')
        return
      }
      this.$message({
        message: this.$l('tips_confirm_ok') || '确认成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async receiveConfirm({ sendSampleCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_receiveConfirm') || '是否确认已签收？',
        this.$l('label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('btn_confirm') || '确定',
          cancelButtonText: this.$l('btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .customerSendSampleReceiveConfirmApi({ sendSampleCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_confirmFailed') || '确认失败！')
        return
      }
      this.$message({
        message: this.$l('tips_confirmSuccess') || '确认成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-tag.el-tag--proofing-c {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
